<template>
    <div class="TestpaperQuesEdit">
        <div class="filters">
            <div class="add">
                <el-button type="primary" @click="openQueImport">题库中导入</el-button>
                <el-button type="primary" @click="openExcelImport">EXCEL导入</el-button>
            </div>
            <div class="search"></div>
        </div>
        <div class="total">共3题，合计18分</div>
        <div class="tq-body">
            <div class="left">
                <questionSetting></questionSetting>
            </div>
            <div class="right">
                <subEdit></subEdit>
            </div>
        </div>
        <excelImport  @getQuesInfo="getQuesInfo" ref="excelImport"></excelImport>
        <questionbankImport @getQueList="getQueList" ref="questionbankImport"></questionbankImport>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import QuestionSetting from 'views/operateTool/testpaper/components/questionSetting.vue'
    import SubEdit from 'views/operateTool/testpaper/components/subEdit.vue'
    import ExcelImport from 'views/operateTool/testpaper/components/excelImport.vue'
    import QuestionbankImport from 'views/operateTool/testpaper/components/questionbankImport.vue'
    export default {
        name: 'TestSubEdit',
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
            // 打开题库中导入弹窗
            openQueImport(){
                this.$refs.questionbankImport.openDialog(this.$route.query.id)
                // this.$refs.selectClassPop.openDialog([data.data])
            },
            // 打开Excel导入弹窗
            openExcelImport() {
                this.$refs.excelImport.openDialog(this.$route.query.id)
            },
            // 导入EXCEL 成功 重新调取接口
            getQuesInfo() {
                // this.findAllHostcatalog()
                // this.findAllQuestionInfo()
            },
            getQueList(){

            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters([
                'permission'
            ])
        },
        components: {
            QuestionSetting, SubEdit,ExcelImport,QuestionbankImport
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .TestpaperQuesEdit {
        font-size: 14px;
        .total{
            color: #303133;
            margin-bottom: 20px;
        }
        .tq-body{
            display: flex;
            justify-content: flex-start;
            .left{
                margin-right: 20px;
            }
            .right{
                flex-grow: 1;
            }
        }
        .el-radio{
            margin-right: 0;
        }
    }
</style>
